"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

interface SearchParamsObserverProps {
  onChange: (queryString: string) => void;
}

/* Keep query-dependent hydration inside its own Suspense boundary. */
export default function SearchParamsObserver({ onChange }: SearchParamsObserverProps) {
  const queryString = useSearchParams().toString();

  useEffect(() => {
    onChange(queryString);
  }, [queryString, onChange]);

  return null;
}
